import React, { useState } from "react";
import PreviewHeader from "./PreviewHeader";

const PreviewFrame = ({
  children,
  data,
  recordId,
  type,
  onViewChange,
  onClose,
}) => {
  const [currentView, setCurrentView] = useState("monitor");

  const handleViewChange = (selectedView) => {
    setCurrentView(selectedView);
    if (onViewChange) {
      onViewChange(selectedView);
    }
  };

  return (
    <div className="flex flex-col bg-gray-50 w-full h-auto">
      {/* Header */}
      <PreviewHeader
        onViewChange={handleViewChange}
        data={data}
        recordId={recordId}
        type={type}
        onClose={onClose}
      />
    
      {/* Background & Content */}
      <div className="flex justify-center py-8 w-full h-full">
        <div data-current-view={currentView}>
            {children(currentView)}
        </div>
      </div>
    </div>
  );
};

export default PreviewFrame;
